const SUCCESS_STATUS = 2000;
const LEGACY_SUCCESS_CODE = 0;

function getPayloadCode(payload) {
  if (!payload || typeof payload !== 'object') {
    return undefined;
  }
  if (payload.status !== undefined) {
    return payload.status;
  }
  return payload.code;
}

function isSuccessPayload(payload) {
  if (!payload || typeof payload !== 'object') {
    return false;
  }
  return payload.status === SUCCESS_STATUS || payload.code === LEGACY_SUCCESS_CODE;
}

function getPayloadMessage(payload) {
  if (!payload || typeof payload !== 'object') {
    return '';
  }
  return payload.message || payload.msg || '';
}

function unwrapApiPayload(payload) {
  if (!isSuccessPayload(payload)) {
    const message = getPayloadMessage(payload) || 'Request failed.';
    throw new Error(message);
  }
  return payload.data;
}

module.exports = {
  SUCCESS_STATUS,
  LEGACY_SUCCESS_CODE,
  getPayloadCode,
  getPayloadMessage,
  isSuccessPayload,
  unwrapApiPayload
};
